import React, {useEffect} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import LiveLocation from './features/liveLocation/LiveLocation';
import Dashboard from './features/dashboard/Dashboard';
import Auth from './features/auth/Auth';
import NotFound from './UI/NotFound';
import LoginScreen from './features/login/LoginScreen';
import {useSelector} from 'react-redux';
import {selectToken} from './features/auth/authSlice';
import OnboardingAuth from './features/onboarding/OnboardingAuth';
import useLoadScripts from './scripts/ScriptProvider';
import AF from './scripts/appsflyer';
import {initFirebaseForAnalytics} from './analytics/firebase';
import {anonSignIn} from './common/anonSignIn';
const {REACT_APP_BASE_NAME} = process.env;


const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};


const primaryFirebaseApp = firebase.initializeApp(firebaseConfig); //for real-time locations, magic links
initFirebaseForAnalytics();


const Router = () => {
    const token = useSelector(selectToken);

    useEffect(() => (process.env.REACT_APP_ENV === 'stage') && anonSignIn(), []);

    const routes = [
        {
            path: ['/', '/login'],
            component: (props) => <Auth database={primaryFirebaseApp} {...props}/>,
        },
        {
            path: '/onboarding-login',
            component: (props) => <OnboardingAuth {...props}/>,
        },
        {
            path: '/live-location',
            component: (props) => <LiveLocation database={primaryFirebaseApp} {...props}/>,
        },
        {
            path: '/signing-in',
            component: (props) => <LoginScreen {...props}/>,
            auth: true
        },
        {
            path: '/dashboard',
            component: () => <Dashboard database={primaryFirebaseApp}/>,
            auth: true
        },
        {
            path: '*',
            component: NotFound,
        },
    ];

    useLoadScripts({script: AF, check: 'AF'});


    return (
        <BrowserRouter basename={REACT_APP_BASE_NAME}>
            <Switch>
                {routes.map((route, i) => {
                    if (route.auth) {
                        if (token) return <Route exact key={i} {...route}/>;

                        return <Redirect key={i} to='/'/>;
                    }
                    return <Route exact key={i} {...route}/>;
                })}
            </Switch>
        </BrowserRouter>
    );
};

export default Router;